import { render, staticRenderFns } from "./ItsBaseMaterType.vue?vue&type=template&id=281948a4&scoped=true&"
import script from "./ItsBaseMaterType.vue?vue&type=script&lang=js&"
export * from "./ItsBaseMaterType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281948a4",
  null
  
)

export default component.exports